import { createContext } from "react";

export const MenuContext = createContext(null);
export const TenantContext = createContext(null);
export const DialogContext = createContext(null);